export const getDicebearAvatar = ({
    style,
    seed,
    size = 128,
    variants = '',
}: {
    style: string;
    seed: string;
    size?: number;
    variants?: string;
}) => {
    return `https://api.dicebear.com/10.x/${style}/svg?seed=${seed}&size=${size}${variants}`;
};
